import React from 'react';
import classnames from 'classnames';
import { Checkbox as AntdCheckbox } from 'antd';
import 'antd/lib/checkbox/style/index.css';
import './Checkbox.scss';

export function Checkbox({ round = false, className, ...props }) {
  return (
    <AntdCheckbox className={classnames('Checkbox', { 'Checkbox_round': round }, className)} {...props} />
  );
}
